export default ".img{\r\n    border: solid 1px rgb(204, 83, 46);\r\n    height: 156px;\r\n    width: 145px;\r\n}\r\n\r\n.search{\r\n    width: 100%;\r\n}";